module.exports = __webpack_public_path__ + "static/media/playlist-add.b08b5ecd.svg";